import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../shared/wizard/steps/baseStep";
import dealServiceSteps from "./dealServiceSteps";

import styles from "./styles.module.scss";

const StepDealService_1 = () => {
  const { goToStep } = useWizard();

  const handleNextStep = () => {
    return goToStep(dealServiceSteps.step_2);
  };

  return (
    <BaseStep nextStep={handleNextStep}>
      <div className={styles.step_1__container}>
        <p className={styles.step_1__text}>
          Сервис сделки — это простой и безопасный способ провести сделку с
          недвижимостью любой сложности.
        </p>
        <p className={styles.step_1__text}>
          Мы берем на себя все детали, работаем быстро, четко и прозрачно. Ваши
          интересы всегда под защитой профессионалов. Стоимость — от 30 000
          рублей.
        </p>
      </div>
    </BaseStep>
  );
};

export default StepDealService_1;
